import * as React from 'react';
import { compose, defaultProps, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import { FontIcon } from '../FontIcon/';
import classNames from 'classnames';
import ButtonMUI from '@material-ui/core/Button';
import { border, transition } from '@topconagriculture/theme';
import { ButtonVariants } from './Button';
const styles = (theme) => createStyles({
    root: {
        width: 85,
        height: 85,
        boxSizing: 'border-box',
        padding: 5,
        borderRadius: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        transition: transition(50),
    },
    primary: {
        backgroundColor: theme.color.primary.main,
        color: theme.color.font.light,
        '&:hover': {
            backgroundColor: theme.color.primary.dark,
        },
        '&:active': {
            backgroundColor: theme.color.primary.dark,
            boxShadow: 'none',
        },
    },
    secondary: {
        backgroundColor: theme.color.background.light,
        border: border(theme.color.grey.light),
        color: theme.color.grey.darkest,
        '&:hover': {
            backgroundColor: theme.color.grey.light,
        },
        '&:active': {
            backgroundColor: theme.color.grey.light,
        },
    },
    withShadow: {
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12)',
    },
    btnDisabled: {
        background: theme.color.grey.light,
        color: `${theme.color.grey.lightest} !important`,
        cursor: 'default',
        boxShadow: 'none',
    },
    iconStyle: {
        lineHeight: 0.6,
    },
});
const RoundButton = (props) => {
    const { classes, className: classNameProp, iconName, iconColor, iconSize, withShadow, variant, testId = 'RoundButton', ...other } = props;
    const iconEl = iconName && (React.createElement(FontIcon, { "data-testid": `${testId}-icon`, iconName: iconName, color: iconColor || 'white', size: iconSize || 50, className: classes.iconStyle }));
    const buttonClasses = classNames(classNameProp, classes.root, {
        [classes.withShadow]: withShadow,
        [classes.primary]: variant === 'primary',
        [classes.secondary]: variant === 'secondary',
    });
    return (React.createElement(ButtonMUI, Object.assign({ "data-testid": `${testId}`, className: buttonClasses, classes: { disabled: classes.btnDisabled } }, other), iconEl));
};
const ComposedRoundButton = compose(pure, withStyles(styles, { withTheme: true }), defaultProps({
    variant: ButtonVariants.primary,
    withShadow: true,
}))(RoundButton);
ComposedRoundButton.displayName = 'RoundButton';
export default ComposedRoundButton;
//# sourceMappingURL=RoundButton.js.map